import React from 'react'

// Import Scss
import './Footer.scss'

const Footer = props => (
  <div className="footer-view">
    <footer className="footer">
      <div className="wrapper">
        <p>© Hatch Healthcare K.K.</p>
      </div>
    </footer>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js